import React from 'react';

const BlogsIn = (props) => {
    const {name,description,image,live}=props.x;
    console.log(name,description,image,live);
    return (
        <div className="dg-in">
            <img src={image} width="100%" height="250px" alt="" />
                       <div className="sbg">
                       <h1>{name.toUpperCase()}</h1>
                        <p className="apps">{description.slice(0,250)}, . . . . .</p>
                        <a href={live} target="_blank"  rel="noreferrer"> <button className="btne">Read More</button> </a>
                       </div>
                    </div>
    );
};

export default BlogsIn;